import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	output,
} from '@angular/core';
import { CmmsEntities } from '@app/domain/types';
import { IRequester } from '@app/pages/cmms/interfaces/request.interfaces';
import { AuPipesModule } from '@app/shared/pipes/au-pipes.module';
import { DateAgoPipe } from '@app/shared/pipes/date-ago.pipe';
import { DateSortingPipe } from '@app/shared/pipes/sort-date.pipe';
import { CommentInputComponent } from '@app/shared/ui-components/au-comments/comment-input/comment-input.component';
import {
	IAuComment,
	IAuCommentEditEvent,
} from '@app/shared/ui-components/au-comments/i-au.comment';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { EntityCommentItemComponent } from './entity-comment-item/entity-comment-item.component';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';

@Component({
	selector: 'entity-comments',
	imports: [
		CommentInputComponent,
		EntityCommentItemComponent,
		NgxTolgeeModule,
		DateSortingPipe,
		AuPipesModule,
		CommonModule,
		MatMenuModule,
	],
	providers: [DateAgoPipe],
	templateUrl: './entity-comments.component.html',
	styleUrl: './entity-comments.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityCommentsComponent {
	private readonly dateAgoPipe = inject(DateAgoPipe);

	commentsList = input<IAuComment[]>([]);
	requester = input<IRequester[]>([]);
	entity = input<CmmsEntities>();

	deleteComment = output<{ commentId: string }>();
	editComment = output<IAuCommentEditEvent>();
	commentSubmitted = output<{
		commentText: string;
		sendAsEmail: boolean;
		mentions: string[];
	}>();

	commentsWithSeparators = computed<IAuComment[]>(() => {
		const reversedComments: IAuComment[] = this.commentsList()?.slice().reverse();

		let lastDay: string | null = null;
		return reversedComments?.map(comment => {
			const day = this.dateAgoPipe.transform(comment.created, false);
			const show = day !== lastDay;
			lastDay = day;
			return { ...comment, showSeparator: show };
		});
	});
}
